import * as React from 'react';
import { clsx } from 'clsx';

type SupportedTag =
  | 'div'
  | 'span'
  | 'section'
  | 'article'
  | 'header'
  | 'footer'
  | 'main'
  | 'p'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6';

/**
 * Factory for reusable HTML elements with fixed Tailwind classes;
 * forwards all native props and ref to the underlying element.
 */
export function createComponent<T extends SupportedTag>(
  tag: T,
  defaultClassName: string
) {
  type Props = React.ComponentPropsWithoutRef<T>;
  type Ref = React.ComponentRef<T>;

  return React.forwardRef<Ref, Props>(({ className, ...props }, ref) =>
    React.createElement(tag, {
      ...props,
      ref,
      className: clsx(defaultClassName, className)
    })
  );
}
